import { useEffect, useState } from 'react';

/**
 * Stateful value that tracks if Segment `window.analytics` is available.
 * Does not differentiate between stub or fully-loaded SDK.
 */
export const useIsSegmentLoaded = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const callback = () => {
      if (window.analytics) {
        clearInterval(maybeAnalytics);
        clearTimeout(maybeAnalyticsMaxTimeout);
        setIsLoaded(true);
      }
    };

    const maybeAnalytics = setInterval(callback, 10);
    const maybeAnalyticsMaxTimeout = setTimeout(() => {
      // eslint-disable-next-line no-console
      console.error('window.analytics not available after 2 seconds, aborting');
      clearInterval(maybeAnalytics);
    }, 2_000);

    // If the order of scripts is set up correctly, this
    // should always resolve on the first call.
    callback();

    return () => {
      clearInterval(maybeAnalytics);
      clearTimeout(maybeAnalyticsMaxTimeout);
    };
  }, []);

  return isLoaded;
};
